import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "panel", "firstField"]
  static values = {
    openOnLoad: { type: Boolean, default: false }
  }

  connect() {
    this.isOpen = false

    if (this.openOnLoadValue) {
      this.open()
    }
  }

  disconnect() {
    if (this.isOpen) {
      document.body.classList.remove("overflow-hidden")
    }
  }

  open(event) {
    event?.preventDefault()

    this.isOpen = true
    this.modalTarget.setAttribute("aria-hidden", "false")
    this.modalTarget.classList.remove("pointer-events-none", "opacity-0")
    this.panelTarget.classList.remove("translate-y-6", "opacity-0", "sm:scale-95")
    document.body.classList.add("overflow-hidden")

    requestAnimationFrame(() => this.firstFieldTarget?.focus())
  }

  close(event) {
    event?.preventDefault()

    if (!this.isOpen) return

    this.isOpen = false
    this.modalTarget.setAttribute("aria-hidden", "true")
    this.modalTarget.classList.add("pointer-events-none", "opacity-0")
    this.panelTarget.classList.add("translate-y-6", "opacity-0", "sm:scale-95")
    document.body.classList.remove("overflow-hidden")
  }

  backdropClose(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }
}
